import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, Loader2 } from "lucide-react";
import {
  Popover, PopoverContent, PopoverTrigger,
} from "@/components/ui/popover";
import { api } from "@/lib/api";

export function NotificationBell() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/assistant/notifications?limit=10");
      setItems(r.data || []);
      setUnread((r.data || []).filter((n) => n.status === "unread").length);
    } catch (_) {} finally { setLoading(false); }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  return (
    <Popover open={open} onOpenChange={(v) => { setOpen(v); if (v) load(); }}>
      <PopoverTrigger asChild>
        <button
          aria-label="Notifications"
          className="relative rounded-lg p-2 text-white/65 hover:bg-white/5 hover:text-white"
          data-testid="topbar-notif-bell"
        >
          <Bell className="h-4 w-4" />
          {unread > 0 && (
            <span className="absolute right-1 top-1 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-fuchsia-500 px-1 text-[10px] font-medium text-white" data-testid="topbar-notif-count">
              {unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 border-white/10 bg-[#0a0a0a] p-0 text-white" data-testid="topbar-notif-popover">
        <div className="flex items-center justify-between border-b border-white/5 p-3">
          <div className="font-display text-base font-light">Assistant briefings</div>
          <Link to="/app/assistant" onClick={() => setOpen(false)} className="text-xs text-fuchsia-300 hover:underline">Open all →</Link>
        </div>
        <div className="max-h-72 overflow-y-auto">
          {loading ? (
            <div className="flex items-center justify-center py-6 text-white/45"><Loader2 className="h-4 w-4 animate-spin" /></div>
          ) : items.length === 0 ? (
            <div className="p-6 text-center text-xs text-white/45">No notifications.</div>
          ) : (
            items.slice(0, 5).map((n) => (
              <Link key={n.id} to="/app/assistant" onClick={() => setOpen(false)} className="block border-b border-white/5 p-3 hover:bg-white/[0.03]">
                <div className="flex items-start gap-2">
                  <div className={`mt-1 h-2 w-2 flex-shrink-0 rounded-full ${n.status === "unread" ? "bg-fuchsia-400" : "bg-white/20"}`} />
                  <div className="min-w-0">
                    <div className="truncate text-sm text-white">{n.title}</div>
                    <div className="line-clamp-1 text-xs text-white/45">{(n.body_md || "").replace(/[#*_-]/g, " ").slice(0, 90)}</div>
                  </div>
                </div>
              </Link>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
